<template lang="pug">
  transition(name="menu-appear")
    #Menu(:class="{ 'is-open': menuOpened }")

      transition(v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:leave="leave" v-bind:css="false")
        .Menu_contentMask(v-if="menuOpened")
          .Menu_content(ref="content")

            .Menu_langs(v-if="settings.display_language_switcher === true")
              a(href='/en' :class="{ 'is-active': $i18n.locale == 'en' }").Menu_langLink EN
              a(href='/fr' :class="{ 'is-active': $i18n.locale == 'fr' }").Menu_langLink FR

            ul.Menu_socials
              li(v-for="(item, index) in socials", ref="socialItems", :key="item.id")
                a(:href="item.url", v-if="item.external" target="_blank") {{ item.title }}
                router-link(:to="item.url", v-else) {{ item.title }}
                <div class="sep"></div>

            .Menu_container
              MenuSearchInput(ref="search")
              MenuItem(v-for="(item, index) in items", ref="menuItems", :key="item.id", :index="index", :title="item.title", :url="item.url")

            ul.Menu_legals
              li.Menu_legals_logo
                a(href="https://www.unilasalle.fr/", target="_blank")
                  img(src="/img/logos/unilasalle-logo-black.svg")
              li.Menu_legals_nav
                ul
                  li(v-for="(item, index) in legals", :key="item.id", ref="legalItems").Menu_legals_items
                    a(:href="item.url" v-if="item.external" v-bind='item.attributes') {{ item.title }}
                    router-link(:to="item.url", v-else) {{ item.title }}
              li.Menu_legals_btn
                FooterDonation(theme="dark" borders=true)
              li.Menu_legals_feder
                a(href="https://europe-en-hautsdefrance.eu/", target="_blank")
                  img(src="/img/logos/logo_FEDER.png")

      .Menu_toggle_button(@click="toggle")
        p(v-if="menuOpened") {{ $t('menu.toggle.close') }}
        p(v-else) {{ $t('menu.toggle.open') }}

        .Menu_toggle_ico
          .barre
          .barre
          .barre

</template>

<script>

import store from '@/store'
import MenuItem from '@/components/MenuItem'
import MenuSearchInput from '@/components/MenuSearchInput'
import FooterDonation from '@/components/FooterDonation'
import { mapGetters, mapActions } from 'vuex'
import { TimelineLite, Power2 } from 'gsap'

export default {
  data () {
    return {
      items: null,
      legals: null,
      socials: null
    }
  },
  computed: {
    ...mapGetters(['menuOpened']),
    ...mapGetters(['settings'])
  },
  components: {
    MenuItem,
    MenuSearchInput,
    FooterDonation
  },
  created () {
    this.$api.getMenu(this.$i18n.locale)
      .then(response => {
        this.items = response.data.main
        this.socials = response.data.socials
        this.legals = response.data.legals
      })
  },
  methods: {
    ...mapActions([
      'setSearchOpen'
    ]),
    toggle () {
      store.dispatch('setMenuOpen', !this.menuOpened)
    },
    /**
     * Avant l'animation d'ouverture du menu
     * On défini le style des quelques éléments
     */
    beforeEnter: function (pEl) {
      // Menu Mask
      TweenLite.set(pEl, {
        width: '0%'
      })
      // Menu Content
      // TODO - a retirer si plus utilisé
      // TweenLite.set(this.$refs.content, {
      //   x: '-50%'
      // })
      // Menu Items
      this.$refs.menuItems.forEach((menuItem, i) => {
        TweenLite.set(menuItem.$el, {
          x: -200,
          opacity: 0,
          'will-change': 'transform, opacity'
        })
      })
      // Social Items
      TweenLite.set(this.$refs.socialItems, {
        x: 20,
        opacity: 0,
        'will-change': 'transform, opacity'
      })
      // Legal Items
      TweenLite.set(this.$refs.legalItems, {
        opacity: 0,
        'will-change': 'opacity'
      })
      // Search
      TweenLite.set(this.$refs.search.$el, {
        scale: 0.9,
        opacity: 0,
        'will-change': 'transform, opacity'
      })
    },
    /**
     * Animation d'apparition du menu
     */
    enter: function (pEl, done) {
      // this.setSearchOpen(false)

      const timeline = new TimelineLite({ onComplete: done })
      // Menu Mask
      timeline.to(pEl, 0.8, {
        width: '100%'
      })
      // Menu Items - fadeIn & horizontalSlide
      timeline.addLabel('menuItems', 0.1)
      // Search
      timeline.to(this.$refs.search.$el, 0.8, {
        scale: 1,
        opacity: 1,
        ease: Power2.easeOut
      }, 'menuItems')
      this.$refs.menuItems.forEach((menuItem, i) => {
        timeline.to(menuItem.$el, 0.8, {
          x: 0,
          opacity: 1,
          ease: Power2.easeOut
        }, `menuItems+=${i * 0.075}`)
      })
      timeline.addLabel('otherItems', '-=0.2')
      // Social Items - fadeIn & slideLeft
      this.$refs.socialItems.forEach((socialItem, i) => {
        timeline.to(socialItem, 0.5, {
          x: 0,
          opacity: 1,
          ease: Power2.easeOut
        }, `otherItems+=${i * 0.075}`)
      })
      // Legal Items - fadeIn
      this.$refs.legalItems.forEach((legalItems, i) => {
        timeline.to(legalItems, 0.5, {
          opacity: 1,
          ease: Power2.easeOut
        }, `otherItems+=${i * 0.075}`)
      })
    },
    /**
     * Animation de disparition du menu
     */
    leave: function (pEl, done) {
      const timeline = new TimelineLite({ onComplete: done })
      // Legal Items - fadeOut
      timeline.to(this.$refs.legalItems, 0.5, {
        opacity: 0,
        ease: Power2.easeIn
      })
      // Search
      timeline.to(this.$refs.search.$el, 0.5, {
        scale: 0.9,
        opacity: 0,
        ease: Power2.easeIn
      }, '-=.2')
      // Social Items - fadeOut & slideRight
      this.$refs.socialItems.reverse().forEach((socialItem, i) => {
        timeline.to(socialItem, 0.5, {
          x: 20,
          opacity: 0,
          ease: Power2.easeIn
        }, i * 0.075)
      })
      // Menu Items - fadeOut & slideLeft
      this.$refs.menuItems.reverse().forEach((menuItem, i) => {
        timeline.to(menuItem.$el, 0.5, {
          x: -50,
          opacity: 0,
          ease: Power2.easeIn
        }, i * 0.075)
      })
      // Menu content - léger slideLeft (pour donner une impression que tous les éléments s'animent)
      timeline.to(this.$refs.content, 0.7, {
        x: '-15%',
        ease: Power2.easeIn
      }, 0.3)
      // Menu Mask
      timeline.to(pEl, 0.6, {
        width: '0%',
        ease: Power3.easeIn
      }, 0.4)
    }
  }
}
</script>

<style lang="stylus" scoped>

  #Menu
    z-index 15
    position relative

    &.menu-appear-enter
      .Menu_toggle_button
        opacity: 0
        transform translate(-100%,0)

    &.menu-appear-enter-active
      .Menu_toggle_button
        opacity: 1
        transition all 1s $ease
    //--- fin animation

    .Menu_langs
      position: absolute
      top 20px
      right 20px
      width: auto
      display flex

      @media $mq_m
        top 30px
        right 50px

      .Menu_langLink
        box-sizing border-box
        width 40px
        height @width
        line-height @width
        border-radius 50%
        text-align center
        cursor pointer
        font-weight 200
        font-size: 12px;
        letter-spacing: 0.1em;
        border 1px solid transparent
        color: $black
        text-decoration: none
        display: inline-block
        transition: border-color .3s $ease

        @media $mq_m
          font-size: 14px;
          width 50px
          height @width
          line-height @width

        & + .Menu_langLink
          margin-left 5px

        &:hover
        &.is-active
          border-color currentColor
          font-weight 600

    .Menu_socials

      position absolute
      top 70px
      right 20px
      text-align right
      padding 0
      margin 0
      display flex
      flex-direction column
      align-items flex-end

      @media $mq_s_only
        display: flex
        flex-wrap wrap
        flex-direction: row-reverse
        align-items: flex-start
        justify-content: flex-start
        max-width 50%

      @media $mq_m
        top 90px
        right 50px

      @media $mq_xl
        top 120px

      li

        font-weight 600
        font-size: 12px;
        text-transform uppercase
        letter-spacing: .15em;
        list-style none
        display block
        position relative
        margin-right 0px

        &:hover

          a

            opacity 0.3

        @media $mq_s_only
          margin 2px 5px

        @media $mq_m
          font-size: 16px;
          padding 20px 0

        a
          color $black
          text-decoration none
          transition opacity 1s $ease

        .sep
          display: block
          transition width 0.8s $ease
          position absolute
          top 0
          right 0
          margin 0

          @media $mq_s_only
            display: none

        &:first-child

          .sep

            display none

    .Menu_contentMask
      position fixed
      top 0
      left 0
      bottom 0
      width 0%
      overflow hidden

    .Menu_content
      position relative
      left $menu_bar_width_mobile
      width 'calc(100vw - %s)' % $menu_bar_width_mobile
      box-sizing border-box
      padding 20px 20px 0px 20px
      display flex
      max-height 100vh
      min-height 100vh
      flex-direction column
      align-items center
      justify-content space-between
      overflow-y auto
      background-color $beige
      background-image url('/img/backgrounds/menu_background.png')
      background-position 100% 50%
      background-repeat no-repeat
      background-size auto 100%

      @media $mq_m
        width 'calc(100vw - %s)' % $menu_bar_width
        left $menu_bar_width
        padding 40px 40px 0px 40px

      @media $mq_l
        padding 55px 50px 0px 50px

      @media $mq_s_only

        height 100%
        overflow-y auto
        padding-top 150px

    .Menu_container

      position relative
      width 50%
      margin auto auto

      @media $mq_m

        width auto

      @media $mq_l

        width 50%

      @media $mq_s_only

        width 100%

      li

        width 100%
        padding 10px 25px
        box-sizing border-box
        list-style none
        border-bottom 1px solid $black

        @media $mq_m
          padding 22px 37px

        @media $mq_xl
          padding 30px 50px

        @media screen and (max-height: 850px)

          padding  20px 50px

        &:last-child

          border-bottom 0px

    .Menu_legals
      position relative
      left 0
      padding 20px 20px
      display block
      box-sizing border-box
      width 100%
      flex-direction row
      margin 0px
      flex-wrap wrap
      align-items center
      justify-content: flex-start

      @media $mq_m
        padding 40px 0px
        display flex

      @media $mq_xl
        padding 50px 0px

      @media $mq_s_only

        position relative
        bottom unset
        margin-top 20px
        justify-content left
        padding 0px
        padding-bottom 60px

      &_items

        &:after

          content ''
          left 50%
          transform translateX(-50%)
          width 0%
          position absolute
          bottom -3px
          height 1px
          background-color $black
          transition width 0.8s $ease

          @media $mq_s_only
            display none

        &:hover

          &:after

            width 110%

      li
        margin 0px

        &:first-child

          @media $mq_s_only
            text-align center
            width 100%

          @media $mq_m
            display flex

        &.Menu_legals_logo
          margin-right 60px

        &.Menu_legals_nav
          flex: 1;
          margin-right 20px

          ul
            list-style none
            position relative
            left 0
            padding 20px 0px
            display block
            box-sizing border-box
            width 100%
            flex-direction row
            margin 0px
            flex-wrap wrap
            align-items center
            justify-content: flex-start

            @media $mq_m
              display flex

            li
              margin-right 30px
              padding 8px 0px
              list-style none
              position relative
              text-transform uppercase
              font-weight 200
              font-size: 12px;
              letter-spacing: 0.05em;

              &:last-child
                margin-right 0px

              @media $mq_m
                font-size: 14px;
                letter-spacing: 0.1em;

              a
                color $black
                text-decoration none

              img
                margin 0 auto

        &.Menu_legals_btn
          padding 20px 0px

          .FooterDonation
            position relative
            bottom 0px
            right 0px

        &.Menu_legals_feder
          width 100%

          a
            width 100px

            img
              position: relative;
              width: 100%;

          @media $mq_l
            position: absolute;
            width 140px
            right: 0;
            top: 0;
            transform: translateY(-40px)

            a
              width 100%

    .Menu_toggle_button
      top 0
      left 0
      bottom 0
      height 100%
      width $menu_bar_width_mobile
      position fixed
      cursor pointer
      transition all 0.8s $ease
      background-color $beige

      &:hover

        p

          letter-spacing 5px

        .Menu_toggle_ico

          .barre

            height 32px

            @media $mq_m

              height 40px

            &:nth-child(2)

              height 20px

              @media $mq_m

                height 30px

      @media $mq_m
        width $menu_bar_width

      p

        position absolute
        top 50%
        left 50%
        text-transform uppercase
        transform: translate(-50%, -50%) rotate(-90deg);
        font-weight 600
        font-size: 12px;
        letter-spacing: 2px;
        text-align: center;
        transition letter-spacing 0.8s $ease

        @media $mq_m
          font-size: 16px;
          letter-spacing: 2px;

    .Menu_toggle_ico

      position absolute
      left 50%
      bottom 20px
      transform translateX(-50%)
      display flex
      flex-direction row

      .barre

        width 2px
        height 22px
        margin-bottom 0px
        margin-top auto
        transition all 0.8s $ease
        background-color $black
        transform-origin 50%

        @media $mq_m
          height 30px

        &:nth-child(2)

          margin auto 5px 0px
          height 30px

          @media $mq_m
            height 40px
            margin auto 7px 0px

    .FooterDonation
      // display: none

      @media $mq_xl
        display: block

    &.is-open

      .Menu_toggle_button

        background-color $black
        color $beige

      .Menu_toggle_ico

        .barre

          background-color white

          &:nth-child(2)

            height 0px!important

          &:nth-child(1)

            transform translate3d(7px, 2px, 0) rotate(45deg)

            @media $mq_m
              transform translate3d(9px, 2px, 0) rotate(45deg)

          &:nth-child(3)

            transform translate3d(-7px, 2px, 0) rotate(-45deg)

            @media $mq_m
              transform translate3d(-9px, 2px, 0) rotate(-45deg)

</style>
